import { render, staticRenderFns } from "./AdmLogin.vue?vue&type=template&id=dff80692&"
import script from "./AdmLogin.vue?vue&type=script&lang=js&"
export * from "./AdmLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports